var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications"},_vm._l((_vm.notifications),function(notification){return _c('notification',{key:notification.id,attrs:{"notification":notification},on:{"dismiss":_vm.onDismiss}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }